import { monthMap, MINIMUM_SIGNUP_AGE } from '@/constants';

interface ParseBirthDateParams {
	day?: string | number;
	month?: string | number;
	year?: string | number;
}

export function parseBirthDate({ day, month, year }: ParseBirthDateParams): Date | null {
	if (!day || !month || !year) return null;

	const d = parseInt(day.toString(), 10);
	const y = parseInt(year.toString(), 10);
	if (Number.isNaN(d) || Number.isNaN(y)) return null;

	const monthKey = month.toString().toLowerCase();

	const m = monthMap[monthKey as keyof typeof monthMap];
	if (m == null) return null;

	const date = new Date(y, m, d);
	return Number.isNaN(date.getTime()) ? null : date;
}

export function isAtLeastMinimumSignupAge(
	birthDate: Date | null,
	referenceDate = new Date()
): boolean {
	if (!birthDate) return false;

	const minimumBirthDate = new Date(
		referenceDate.getFullYear() - MINIMUM_SIGNUP_AGE,
		referenceDate.getMonth(),
		referenceDate.getDate()
	);

	return birthDate <= minimumBirthDate;
}

export const extractGoogleTokenPayload = (
	result: any
): { idToken?: string; accessToken?: string } | null => {
	if (!result) return null;

	const idToken = result.idToken || result.identityToken || result.token || result.id_token;
	if (idToken) {
		return { idToken };
	}

	const accessToken = result.accessToken || result.access_token;
	if (accessToken) {
		return { accessToken };
	}

	return null;
};
